<script setup lang="ts">
const properties = defineProps<{
  data: any
}>()
</script>

<template>
  <div class="prose !max-w-full flex-1" v-html="data.translations[0].text" />
</template>
